import React from 'react';
import { DispatchProp } from 'react-redux';
import { useSetResolved } from 'src/core/engine/router';
import { CmsAboutPage } from 'src/components/CmsPage/CmsAboutPage';
import { DefaultMeta } from 'src/components/AppShell/Head';

import '../../scss/_root-component.scss';

import meta from './CmsAbout.json';

type Props = {
    id: number;
} & DispatchProp<any>;

export const CmsAbout: React.FC<Props> = () => {
    useSetResolved();

    return (
        <>
            <DefaultMeta data={meta.helmet} />
            <CmsAboutPage />
        </>
    );
};

export default CmsAbout;
